<template>
  <div>
    <app-header></app-header>

    <div class="container content">
      <div class="no-players">
        <div class="text">
          Cамоконтроль рисков нарушения антимонопольного законодательства.
          <br>
          Добро пожаловать!
          <br>
        </div>
        <div class="col">
          <form @submit.prevent="login">
            <div class="form-group">
              <label>Email</label>
              <input type="text" id="email" v-model="email" autofocus>
            </div>
            <div class="form-group">
              <label>Пароль</label>
              <input type="password" id="password" v-model="password">
            </div>
            <div class="form-group" style="justify-content: end">
              <button class="btn" type="submit">Войти</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</template>

<script>
  export default {
    name: 'AdminLogin',
    data () {
      return {
        email: '',
        password: '',
        slug: process.env.ORG_SLUG
      }
    },
    methods: {
      login () {
        let router = this.$router
        this.$store.dispatch('signin',
          {
            email: this.email,
            password: this.password,
            callback () {
              router.push({name: 'Players'})
            }
          })
      }
    },
    created () {
      this.$store.dispatch('signout')
    }
  }
</script>

<style scoped lang="scss">

.no-players {
  margin: 10vh 0;
  .text {
    color: #000 !important;
    font-weight: 400;
  }
  .btn {
    display: block;
    margin: 20px auto;
  }
}

.col {
  width: 485px;
  max-width: 100%;
  margin: 0 auto;
}

.form-group {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .btn {
    margin: 20px 0;
  }
}

.content {
  min-height: calc(100vh - 212px);
}
</style>



// WEBPACK FOOTER //
// src/pages/admin/AdminLogin.vue